// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__r3iF7","listOfInputsInSectionsLayout":"styles_listOfInputsInSectionsLayout__vlUF9","listOfInputs":"styles_listOfInputs__S8wCR"};